import { useQuery } from 'react-query';
import axiosConn from '../axiosConn';

// Converted to react-query from useState api call.
const getConversations = async ({ queryKey }) => {
  const player = queryKey[1];
  // Guard: if player or player.data/player.data.player is missing, return empty array
  if (
    !player ||
    !player.data ||
    !player.data.player ||
    !player.data.player._id
  ) {
    return [];
  }
  try {
    const res = await axiosConn.get(
      '/conversations/' + player.data.player._id,
      {
        headers: {
          Authorization: `Bearer ${player.token}`,
        },
      },
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const useGetConversations = (onSuccess, onError, player) => {
  return useQuery(['getConversations', player], getConversations, {
    enabled: !!(
      player &&
      player.data &&
      player.data.player &&
      player.data.player._id
    ),
    onSuccess,
    onError,
  });
};
